import type { BaseModalProps } from '@byecode/ui'
import { DesktopModal, Modal } from '@byecode/ui'
import React from 'react'

import QwenAccount from './QwenAccount'

interface QwenAccountModalProps extends BaseModalProps {}

export const QwenAccountModal: React.FunctionComponent<QwenAccountModalProps> = ({ ...rest }) => {
    return (
        <DesktopModal
            width={676}
            {...rest}
            styles={{
                modal: {
                    maxHeight: 'calc(100% - 48px)'
                },
                body: {
                    padding: '0!important'
                },
                header: {
                    borderStyle: 'none'
                }
            }}
        >
            <QwenAccount onClose={rest.onClose} />
        </DesktopModal>
    )
}
